export const postsTypes = [
	'CASHTRACK-POST',
	'NEWS-POST',
	'BLITZ-POST',
	'WPP-POST',
	'INTERVIEW-POST',
];
